import SectionIds from "../../../Helper/SectionId";

// Define individual nav items
const navItems = {
  home: {
    item: 'Home',
    route: `/#${SectionIds.sectionHome}`
  },
  dematAccount: {
    item: 'Demat Account',
    route: `/#${SectionIds.sectionDemat}`
  },
  services: {
    item: 'Services',
    route: `/#${SectionIds.sectionWGYC}`
  },
  investingOptions: {
    item: 'Investing Options',
    route: `/#${SectionIds.sectionInvestingOptions}`
  },
  aboutMe: {
    item: 'About Me',
    route: `/#${SectionIds.sectionAboutMe}`
  },
  sipCalculator: {
    item: 'Sip Calculator',
    route: `/sip-calculator#${SectionIds.sectionSipCalculator}`
  },
  contactMe: {
    item: 'Contact Me',
    route: `/#${SectionIds.sectionContactMe}`
  }
};


const HomeNavItems = [
  navItems.dematAccount,
  navItems.services,
  navItems.investingOptions,
  navItems.aboutMe,
  navItems.sipCalculator
];
const SipNavItems = [
  navItems.home,
  navItems.dematAccount,
  navItems.services,
  navItems.investingOptions,
  navItems.aboutMe,
];

const HomeDropdownNavItems = [
  navItems.dematAccount,
  navItems.services,
  navItems.investingOptions,
  navItems.aboutMe,
  navItems.contactMe,
  navItems.sipCalculator
]
const SipCalculatorDropdownNavItems = [
  navItems.home,
  navItems.dematAccount,
  navItems.services,
  navItems.investingOptions,
  navItems.aboutMe,
  navItems.contactMe,
]
const FooterNavItems = [
  navItems.home,
  navItems.dematAccount,
  navItems.services,
  navItems.investingOptions,
  navItems.aboutMe,
  navItems.sipCalculator,
  navItems.contactMe
]
export { HomeNavItems, SipNavItems, FooterNavItems, HomeDropdownNavItems, SipCalculatorDropdownNavItems };